/**
 * Currency conversion utilities for handling monetary values in paise.
 */

/**
 * Convert rupees to paise (multiply by 100, round to avoid float issues).
 * @param {number|string} rupees - Amount in rupees
 * @returns {number} Amount in paise (integer)
 */
export const toPaise = (rupees) => Math.round(parseFloat(rupees || 0) * 100);

/**
 * Convert paise to rupees for display.
 * @param {number} paise - Amount in paise
 * @returns {number} Amount in rupees
 */
export const toRupees = (paise) => (paise || 0) / 100;

/**
 * Format paise as rupees string with 2 decimal places.
 * @param {number} paise - Amount in paise
 * @returns {string} Formatted string like "₹123.45"
 */
export const formatRupees = (paise) => `₹${toRupees(paise).toFixed(2)}`;

/**
 * Parse user input and convert to integer (for both paise and percentage).
 * Validates that the input is a whole number.
 * @param {string|number} value - User input value
 * @returns {number|null} Parsed integer or null if invalid
 */
export const parseWholeNumber = (value) => {
    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) return null;
    // Check if the original value had decimals
    if (parseFloat(value) !== parsed) return null;
    return parsed;
};

/**
 * Validate that a value is a whole number (no decimals).
 * @param {string|number} value - Value to validate
 * @returns {boolean} True if whole number
 */
export const isWholeNumber = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && Number.isInteger(num);
};
